export const SEARCHED_REF_NUMBER = 'SEARCHED_REF_NUMBER';



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/actions.ts